import { createRouter, createWebHistory } from 'vue-router';
import SignInView from '../views/SignInView.vue';

const routes = [
  {
    path: '/',
    name: 'signin',
    component: SignInView,
    meta: {
      title: 'Anmelden',
    },
  },
];

const router = createRouter({
  history: createWebHistory('/signin/'),
  routes,
});

router.beforeEach((to, _from, next) => {
  document.title = to.meta?.title
    ? `${to.meta.title} – PensExpert`
    : 'PensExpert Anmeldung';
  next();
});

export default router;
